import { render, staticRenderFns } from "./msgmanage.vue?vue&type=template&id=c2cd4a12&scoped=true&"
import script from "./msgmanage.vue?vue&type=script&lang=js&"
export * from "./msgmanage.vue?vue&type=script&lang=js&"
import style0 from "./msgmanage.vue?vue&type=style&index=0&id=c2cd4a12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cd4a12",
  null
  
)

export default component.exports